export function extractTimeFromDate(timerDate) {
  let hours = parseInt((timerDate / (1000 * 60 * 60)) % 24, 10);
  let minutes = parseInt((timerDate / (1000 * 60)) % 60, 10);
  let seconds = parseInt((timerDate / 1000) % 60, 10);

  if (hours < 10) {
    hours = `0${hours}`;
  }

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  if (seconds < 10) {
    seconds = `0${seconds}`;
  }

  return {
    hours,
    minutes,
    seconds,
  };
}

export function extractDate(date) {
  const dateObj = new Date(date);
  let day = dateObj.getDate();
  let month = dateObj.getMonth() + 1;
  let year = `${dateObj.getFullYear()}`.slice(-2);

  if (day < 10) {
    day = `0${day}`;
  }

  if (month < 10) {
    month = `0${month}`;
  }

  if (year < 10) {
    year = `0${year}`;
  }

  return {
    day,
    month,
    year,
  };
}

export function nth(d) {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}
